<template>
  <!-- Show Dispatch Details in a Popup Modal -->
  <div v-if="showModal" ref="modalContent" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>

      <!-- Show Dispatch Details -->
      <div class="dispatch-header">
        <img src="../../assets/images/logo/gas_logo.png" alt="Laugfs Gas Logo" class="logo">
        <div class="dispatch-details">
          <div>

            <strong>Dispatch No:</strong> {{ dispatch.dispatch_no }}<br>
            <strong>Created At:</strong>{{ dispatch.created_at }}<br>
            <strong>Vehicle:</strong> {{ dispatch.vehicle }}<br>
            <strong>Driver:</strong>  {{ dispatch.driver }}<br>
            <strong>Helper:</strong> {{ dispatch.helper ? dispatch.helper : 'N/A' }}<br>
            <strong>Rep:</strong> {{ dispatch.rep }}<br>
            <strong>Distributor:</strong> {{ dispatch.distributor }}<br>
            <strong>Route:</strong> {{ dispatch.route }}<br>
            <strong>Stock Allocation no:</strong> {{ dispatch.stock_allocation_nos }}<br>

          </div>
        </div>
      </div>

      <table class="table popup-table">
        <thead>
        <tr>
          <th>Item Name</th>
          <th>Quantity</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(items, allocationNo) in stockAllocations" :key="allocationNo">
          <td>{{ items.item_name }}</td>
          <td>{{ parseInt(items.total_qty) }}</td>
        </tr>
        </tbody>
      </table>

      <!-- Show Buttons -->
      <div class="dispatch-actions mt-4">
        <!-- Show Cancel and Reprint buttons only if invoice.is_cancel is "0" (Active) -->
        <button v-if="showCancelButton()" @click="showBottomSheet = true" class="cancel-button">Cancel</button>
        <button @click="printDispatch" class="print-button">Print</button>
        <button @click="closeModal" class="btn button-default">Close</button>
      </div>
    </div>
  </div>

  <!-- Bottom Sheet for Cancel Dispatch -->
  <div v-if="showBottomSheet" class="bottom-sheet-overlay" @click="showBottomSheet = false">
    <div class="bottom-sheet" @click.stop>
      <h3>Cancel Dispatch</h3>
      <label>Remark:</label>
      <textarea
          v-model="cancelRemark"
          class="bottom-sheet-textarea"
          :class="{ 'border-red': remarkError }"
          placeholder="Add your remark here..."
          maxlength="200"
          @input="validateRemark"
      ></textarea>

      <!-- Error Message -->
      <p v-if="remarkError" class="error-message">Please add a remark.</p>

      <!-- Character Counter -->
      <div class="character-counter">
        {{ cancelRemark.length }}/200
      </div>

      <div class="bottom-sheet-actions">
        <button @click="closeBottomSheet" class="btn-exit">Exit</button>
        <button @click="confirmCancel" class="btn-cancel" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else>Cancel Dispatch</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {cancelDispatch, fetchInvoicesByDistributor} from "@/services/dataService";
import { useToast } from 'vue-toastification';
import {useRouter} from "vue-router";

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    dispatch: {
      type: Object,
      required: true
    },
    stockAllocations: {
      type: Object,
      required: true
    },
    dispatchId:{
      type:String,
      required:true
    }
  },

  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem('profile_id'),
      showHistory: true,
      showBottomSheet: false,
      cancelRemark: '',
      remarkError: false,
      loading: false,
    };
  },

  //Show messages in the toaster
  setup() {
    const toast = useToast(); // Initialize the toaster
    return { toast };
  },


  //Functions
  methods: {
    //Format number to currency
    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    //Close Invoice Popup Modal
    closeModal() {
      console.log("Close button clicked");
      this.$emit('close');
    },

    //Print dispatch details
    printDispatch() {
      const printContent = this.$refs.modalContent.innerHTML;
      const originalContent = document.body.innerHTML;
      
      document.body.innerHTML = printContent;
      window.print();
      document.body.innerHTML = originalContent;
      
      // After printing, reload to restore functionality
      window.location.reload();
    },

    //Validate remark field on input change
    validateRemark() {
      if (this.cancelRemark.trim()) {
        this.remarkError = false; // Hide error if user types something
      }
    },

    //Close bottom sheet
    closeBottomSheet() {
      this.showBottomSheet = false;
      this.cancelRemark = ''; // Clear the text
      this.remarkError = false; // Reset the error flag
    },

    showCancelButton() {
      return this.dispatch.sales_rep_confirmed == '0';
    },

    //Call cancel remark API
    async confirmCancel() {
      if (!this.cancelRemark.trim()) {
        this.remarkError = true;
        return;
      }

      try {
        this.loading = true;

        const payload = {
          dispatch_id: this.dispatchId,
          cancel_remark: this.cancelRemark,
        };

        console.log("dispatch id", this.dispatchId);
        console.log("Cancel Payload:", payload);

        const response = await cancelDispatch(this.token, payload);
        console.log("API Response:", response.data);

        if (response.data.status === 'success') {
          this.toast.success(response.data.message || "Dispatch cancelled successfully.");
          this.closeBottomSheet();
          this.closeModal();
        } else {
          this.toast.error(response.data.message || "Failed to cancel dispatch.");
        }
      } catch (e) {
        console.error("Cancel Invoice Error:", e.response?.data || e.message);
        this.toast.error(e.response?.data?.message || "An error occurred while cancelling the invoice.");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  max-width: 100%;;
  width: 100%;
  max-height: 100%; /* Set maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
}

.dispatch-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.logo {
  max-width: 150px;
  margin-bottom: 20px;
}

.dispatch-details {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.dispatch-details div {
  flex: 1;
  margin-right: 20px;
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.invoice-table th, .invoice-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.invoice-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.invoice-summary {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.invoice-summary div {
  text-align: right;
}

.dispatch-actions {
  display: flex;
  justify-content: flex-end;
}

.invoice-history {
  margin-top: 20px;
}

.invoice-history-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.invoice-history-table th, .invoice-history-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.invoice-history-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  margin-left: 10px;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

.cancel-button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f44336;
  color: white;
  margin-right: auto; /* Moves only the Cancel button to the left */
}

.print-button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #4CAF50;
  color: white;
  margin-right: 10px;
}

.print-button:hover {
  background-color: #45a049;
}

/* Bottom Sheet Styles */
.bottom-sheet-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1100;
}

.bottom-sheet {
  background: #fff;
  width: 100%; /* Make it full width */
  padding: 20px;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 100%; /* Ensure it stretches across all screen sizes */
}

.bottom-sheet h3 {
  margin-bottom: 20px;
  text-align: left;
}

.bottom-sheet textarea {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  margin-bottom: 10px;
}

.bottom-sheet textarea:focus {
  border-color: #1c1f23;
  outline: none;
}

.bottom-sheet-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-exit {
  background-color: #ccc;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-cancel {
  background-color: #f44336;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-exit:hover {
  background-color: #999;
}

.btn-cancel:hover {
  background-color: #d32f2f;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: -5px;
}

/* Cancelled Badge Positioning */
.cancelled-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 150px; /* Adjust width of the badge */
  height: auto; /* Maintain aspect ratio */
  z-index: 2000; /* Make sure it's on top */
}

/* Print-specific styles */
@media print {
  body * {
    visibility: hidden;
  }
  .modal-overlay, .modal-overlay * {
    visibility: visible;
  }
  .modal-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    background-color: white;
  }
  .modal-content {
    box-shadow: none;
    border: none;
    width: 100%;
    max-width: 100%;
  }
  .dispatch-actions {
    display: none !important;
  }
}
</style>